import { render, staticRenderFns } from "./MiniButton.vue?vue&type=template&id=c92d9f38&scoped=true&"
import script from "./MiniButton.vue?vue&type=script&lang=js&"
export * from "./MiniButton.vue?vue&type=script&lang=js&"
import style0 from "./MiniButton.vue?vue&type=style&index=0&id=c92d9f38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92d9f38",
  null
  
)

export default component.exports